// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GiftIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27 9h-4.385c.049-.041.099-.081.146-.125A3.691 3.691 0 0 0 24 6.196 4.08 4.08 0 0 0 19.805 2a3.69 3.69 0 0 0-2.68 1.239A6.867 6.867 0 0 0 16 5.049a6.867 6.867 0 0 0-1.125-1.81A3.69 3.69 0 0 0 12.195 2 4.078 4.078 0 0 0 8 6.196a3.691 3.691 0 0 0 1.239 2.679c.047.041.097.081.146.125H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v8a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2Zm-8.375-4.436A1.71 1.71 0 0 1 19.875 4h.061A2.077 2.077 0 0 1 22 6.135a1.71 1.71 0 0 1-.563 1.25c-1.186 1.05-3.155 1.42-4.375 1.55.15-1.324.563-3.248 1.563-4.371Zm-8.011.045A2.079 2.079 0 0 1 12.074 4h.061a1.711 1.711 0 0 1 1.25.563c1.049 1.184 1.419 3.15 1.549 4.365-1.215-.126-3.18-.5-4.365-1.55a1.71 1.71 0 0 1-.563-1.25 2.074 2.074 0 0 1 .603-1.52h.005ZM5 11h10v4H5v-4Zm2 6h8v8H7v-8Zm18 8h-8v-8h8v8Zm2-10H17v-4h10v4Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
